export default "__VITE_ASSET__VEw8u1g$__"